module.exports = __webpack_public_path__ + "media/images/e-bilet/Kyiv__mobile__bg-eafe111b93418b1ef6eab7c103dd8307.jpg";